import { LitElement } from "lit-element";

export class LightDomEl extends LitElement {
    /**
     * Render into the light DOM
     */
    createRenderRoot() {
        return this;
    }
}
